import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import RuleDetailClient from '../components/RuleDetailClient'

function RuleDetailError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load rule.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/rules/$id')({
  head: () => ({
    meta: [{ title: 'Rule Detail | Unbreakable' }],
  }),
  errorComponent: RuleDetailError,
  component: RuleDetailPage,
})

function RuleDetailPage() {
  const { id } = Route.useParams()
  return (
    <AuthGuard>
      <RuleDetailClient policyId={id} initialPolicy={null} initialProtectedBundleIds={[]} />
    </AuthGuard>
  )
}
